/**
 * <ln-video-play>
 *   <video preload="none" …></video>
 *   <button class="ln-media__play">…</button>
 * </ln-video-play>
 *
 * Click-to-play video: loads nothing until clicked, then plays with sound and native controls.
 * Starting one video pauses any other ln-video-play on the page.
 */
if (!customElements.get('ln-video-play')) {
  customElements.define(
    'ln-video-play',
    class LnVideoPlay extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        if (!this.video || !this.button) return;
        this.button.addEventListener('click', () => this.play());
        this.video.addEventListener('play', () => {
          document.querySelectorAll('ln-video-play').forEach((el) => el !== this && el.video?.pause());
        });
      }

      play() {
        this.video.controls = true;
        this.video.muted = false;
        this.button.hidden = true;
        this.video.play().catch(() => {
          // Autoplay with sound can be blocked; fall back to muted playback.
          this.video.muted = true;
          this.video.play().catch(() => {});
        });
      }
    }
  );
}
